import { Country } from '@/app/data/zones';
import { CountryIsoCode } from '@/graphql/graphql';

export type RestrictionType = '' | 'classic' | 'FAST' | 'local_vod';

export type UICountry = Omit<Country, 'restrictionType' | 'active'> & {
    restrictionType?: RestrictionType[];
    active?: boolean;
};

export type TranslatableRestrictionType = Exclude<RestrictionType, ''>;

export type ZoneKey = 'europ' | 'apac' | 'indianSub' | 'latinAmerica' | 'mena' | 'ssa';
export type ZoneLabelKey = `ScreeningRoom.modal.restrictedCountry.zone.${ZoneKey}`;

export type RestrictionTypeKey =
    `ScreeningRoom.modal.restrictedCountry.restrictionType.${Exclude<RestrictionType, ''>}`;

export enum ModalMode {
    ALL_COUNTRIES = 'ALL_COUNTRIES',
    SINGLE_COUNTRY = 'SINGLE_COUNTRY',
}

export interface ExcludedCountriesModalsProps {
    isOpen: boolean;
    onClose: () => void;
    initialExcludedCountries?: Array<{
        country: CountryIsoCode;
        type: RestrictionType[];
    }>;
    onSave: (
        excludedCountries: Array<{
            country: CountryIsoCode;
            type: RestrictionType[];
        }>,
    ) => void;
}
